export default {
  en: {
    triggerLabel: 'Language you are learning: {{language}}',
    menuLabel: 'Choose a language to learn',
    switchFailed: "Couldn't switch the language. Try again.",
  },
  ru: {
    triggerLabel: 'Изучаемый язык: {{language}}',
    menuLabel: 'Выбор изучаемого языка',
    switchFailed: 'Не удалось сменить язык. Попробуйте ещё раз.',
  },
  de: {
    triggerLabel: 'Sprache, die du lernst: {{language}}',
    menuLabel: 'Wähle eine Sprache zum Lernen',
    switchFailed: 'Sprache konnte nicht gewechselt werden. Versuch es nochmal.',
  },
  pt: {
    triggerLabel: 'Idioma que você está aprendendo: {{language}}',
    menuLabel: 'Escolha um idioma para aprender',
    switchFailed: 'Não foi possível trocar o idioma. Tente de novo.',
  },
  fr: {
    triggerLabel: 'Langue que tu apprends : {{language}}',
    menuLabel: 'Choisis une langue à apprendre',
    switchFailed: 'Impossible de changer de langue. Réessaie.',
  },
  es: {
    triggerLabel: 'Idioma que estás aprendiendo: {{language}}',
    menuLabel: 'Elige un idioma para aprender',
    switchFailed: 'No se pudo cambiar el idioma. Inténtalo de nuevo.',
  },
};
